import { createApp } from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import notify from './plugins/notify'
import { router } from './router'

const app = createApp(App)
app.use(vuetify)
app.use(notify)
app.use(router)
app.mount('#app')
